export const SUPPORTED_LANGS = [
  { code: "en", name: "English", dir: "ltr" },
  { code: "ar", name: "العربية", dir: "rtl" },
  { code: "tr", name: "Türkçe", dir: "ltr" },
];

export const TR = {
  en: {
    brand: "KHA GAMES",
    tagline: "Instant Game Account Delivery",
    nav: {
      home: "Home",
      games: "Games",
      verify: "Redeem Key",
      faq: "FAQ",
      contact: "Contact",
      admin: "Admin",
      sign_in: "Sign In",
      sign_up: "Sign Up",
      profile: "Profile",
      logout: "Sign out",
      library: "My Library",
    },
    hero: {
      eyebrow: "Premium Steam Account Marketplace",
      title: "Instant access to Steam games, powered by encrypted delivery.",
      subtitle: "Sign up, redeem a key, pick your game, and receive your account in seconds — Steam Guard codes fetched automatically.",
      cta_primary: "Redeem Your Key",
      cta_secondary: "Browse Games",
    },
    sections: {
      popular: "Featured Games",
      popular_sub: "Available titles ready to claim",
      latest: "Newest Additions",
      latest_sub: "Fresh games in our library",
      how_it_works: "How It Works",
      how_sub: "Three steps. Encrypted. Instant.",
      step1_title: "Buy a Key",
      step1_desc: "Purchase a KHA Games key from our external store.",
      step2_title: "Redeem on Site",
      step2_desc: "Log in, enter your key, pick your game.",
      step3_title: "Get Your Account",
      step3_desc: "Steam credentials + Steam Guard codes on demand.",
      features: "Why KHA Games",
      f_secure: "AES-encrypted",
      f_secure_desc: "Every password is encrypted at rest with Fernet AES.",
      f_instant: "Sub-second delivery",
      f_instant_desc: "Atomic account allocation. No waiting.",
      f_steamguard: "Instant Steam Guard",
      f_steamguard_desc: "Tap one button — the latest login code appears in seconds.",
      f_24_7: "24/7 availability",
      f_24_7_desc: "Buy and play any hour, fully automated.",
    },
    auth: {
      welcome_back: "Welcome back",
      sign_in_sub: "Sign in to redeem your keys and access your library.",
      sign_up_sub: "Create your account to start redeeming keys.",
      identifier: "Username or Email",
      username: "Username",
      email: "Email",
      password: "Password",
      confirm_password: "Confirm Password",
      have_account: "Already have an account?",
      no_account: "Don't have an account?",
      forgot: "Forgot password?",
      forgot_title: "Reset Password",
      forgot_sub: "Enter your username or email and we'll send you a reset link.",
      forgot_sent: "If the account exists, a reset link has been sent.",
      reset_title: "Set new password",
      reset_sub: "Enter your new password below.",
      reset_done: "Password updated. You can sign in now.",
      send_reset: "Send reset link",
      new_password: "New password",
      update_password: "Update password",
      login_required_title: "Sign in required",
          or: "or",
      continue_with_google: "Continue with Google",
      google_welcome: "Welcome!",
      google_finishing: "Finishing Google sign-in…",
      google_failed: "Google sign-in failed",
      google_unavailable: "Google sign-in is not available right now.",
      pwd_mismatch: "Passwords do not match",
      pwd_too_short: "Password must be at least 8 characters",
      account_created: "Account created. Welcome!",
},
    verify: {
      title: "Redeem Your Key",
      subtitle: "Enter the key you purchased.",
      placeholder: "KHA-XXXX-XXXX-XXXX",
      submit: "Verify Key",
      verifying: "Verifying...",
      pick_game: "Choose your game",
      pick_sub: "Pick one game to claim.",
      deliver: "Claim",
      delivering: "Delivering...",
      success: "Your Account",
      copy: "Copy",
      copied: "Copied!",
      username: "Steam Username",
      password: "Steam Password",
      guard_btn: "Get Steam Guard Code",
      guard_fetching: "Searching inbox...",
      guard_title: "Steam Guard Code",
      guard_retry: "Retry",
      guard_close: "Close",
      cooldown_prefix: "Available in",
      cooldown_notice: "Available again in 72 hours.",
      cooldown_next: "Next request",
      cooldown_d: "d",
      cooldown_h: "h",
      cooldown_m: "m",
      no_code: "No new Steam Guard code yet. Try again in a few seconds.",
      gmail_not_connected: "Steam Guard service not yet available for this account. Contact support.",
      warning_save: "Saved to your Library — accessible anytime.",
      view_library: "Go to My Library",
      login_required: "Please sign in or create an account to redeem keys.",
          verified_toast: "Key verified",
      delivered_toast: "Delivered!",
      game_added_prefix: "Game added!",
      uses_remaining_suffix: "uses left",
      no_products: "No products available for this key right now. Please try again later.",
},
    profile: {
      title: "My Library",
      subtitle: "All your claimed games. Steam Guard codes available 24/7.",
      empty: "You haven't claimed any games yet.",
      redeem_first: "Redeem a Key",
      delivered_on: "Claimed on",
      account_info: "Account Info",
      member_since: "Member since",
      change_password: "Change password",
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        { q: "How do I get a key?", a: "Purchase a key from our external store. It will be a code like KHA-XXXX-XXXX-XXXX." },
        { q: "Do I need an account?", a: "Yes — sign up to save every redeemed game in your library forever." },
        { q: "Is my password secure?", a: "Yes. All sensitive data is encrypted with AES-grade encryption at rest." },
        { q: "What if Steam Guard asks for a code?", a: "Click 'Get Steam Guard Code' on any game in your library. The latest login code appears in seconds." },
        { q: "Can I reuse a key?", a: "No — each key is single-use." },
        { q: "Can I access my games later?", a: "Yes! Every redeemed game stays in your library permanently with Steam Guard on demand." },
      ],
    },
    contact: {
      title: "Get in touch",
      subtitle: "Questions, bug reports, partnership inquiries — drop us a line.",
      name: "Your name",
      email: "Email",
      message: "Message",
      send: "Send message",
      sent: "Message received. We’ll respond within 24h.",
    },
    game: {
      view: "View details",
      claim: "Redeem key for this game",
      delivered: "delivered",
    },
    games: {
      search_placeholder: "Search games or platforms…",
      results: "result(s)",
      no_results: "No games match your search.",
    },
    admin: {
      login: "Admin Sign In",
      login_sub: "Sign in to manage KHA Games.",
      email: "Email",
      password: "Password",
      sign_in: "Sign in",
      dashboard: "Dashboard",
      products: "Games",
      user_mgmt: "User Management",
      keys: "Keys",
      logs: "Logs",
      users: "Users",
      logout: "Sign out",
    },
    common: {
      loading: "Loading...",
      empty: "Nothing here yet.",
      error: "Something went wrong.",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      yes: "Yes",
      no: "No",
      confirm: "Confirm",
      search: "Search",
      status: "Status",
      actions: "Actions",
      created: "Created",
    },
  },
  ar: {
    brand: "KHA GAMES",
    tagline: "تسليم حسابات الألعاب فوراً",
    nav: {
      home: "الرئيسية",
      games: "الألعاب",
      verify: "تفعيل المفتاح",
      faq: "الأسئلة الشائعة",
      contact: "تواصل",
      admin: "لوحة التحكم",
      sign_in: "تسجيل دخول",
      sign_up: "إنشاء حساب",
      profile: "حسابي",
      logout: "تسجيل خروج",
      library: "مكتبتي",
    },
    hero: {
      eyebrow: "متجر حسابات Steam المميز",
      title: "وصول فوري لألعاب Steam بتسليم مشفّر بالكامل.",
      subtitle: "أنشئ حساباً، فعّل المفتاح، اختر اللعبة، واستلم الحساب خلال ثوانٍ — مع جلب تلقائي لرمز Steam Guard.",
      cta_primary: "فعّل مفتاحك",
      cta_secondary: "تصفح الألعاب",
    },
    sections: {
      popular: "الألعاب المميزة",
      popular_sub: "ألعاب متاحة جاهزة للاستلام",
      latest: "الإضافات الجديدة",
      latest_sub: "أحدث الألعاب في مكتبتنا",
      how_it_works: "كيف يعمل النظام",
      how_sub: "ثلاث خطوات. مشفّر. فوري.",
      step1_title: "اشترِ مفتاحاً",
      step1_desc: "احصل على مفتاح KHA Games من متجرنا الخارجي.",
      step2_title: "فعّل المفتاح",
      step2_desc: "سجّل الدخول، أدخل المفتاح، اختر اللعبة.",
      step3_title: "استلم حسابك",
      step3_desc: "بيانات Steam ورمز Guard عند الطلب.",
      features: "لماذا KHA Games",
      f_secure: "تشفير AES كامل",
      f_secure_desc: "كل كلمة مرور مشفّرة في قاعدة البيانات.",
      f_instant: "تسليم تحت الثانية",
      f_instant_desc: "تخصيص ذرّي للحسابات. لا انتظار.",
      f_steamguard: "Steam Guard فوري",
      f_steamguard_desc: "زر واحد — يظهر آخر رمز تسجيل دخول خلال ثوانٍ.",
      f_24_7: "متاح 24/7",
      f_24_7_desc: "اشترِ والعب في أي وقت، آلية كاملة.",
    },
    auth: {
      welcome_back: "أهلاً بعودتك",
      sign_in_sub: "سجّل الدخول لتفعيل مفاتيحك وتصفّح مكتبتك.",
      sign_up_sub: "أنشئ حسابك للبدء بتفعيل المفاتيح.",
      identifier: "اسم المستخدم أو البريد الإلكتروني",
      username: "اسم المستخدم",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      confirm_password: "تأكيد كلمة المرور",
      have_account: "لديك حساب بالفعل؟",
      no_account: "ليس لديك حساب؟",
      forgot: "نسيت كلمة المرور؟",
      forgot_title: "استعادة كلمة المرور",
      forgot_sub: "أدخل اسم المستخدم أو البريد لنرسل لك رابط الاستعادة.",
      forgot_sent: "إن كان الحساب موجوداً، فقد تم إرسال رابط الاستعادة.",
      reset_title: "تعيين كلمة مرور جديدة",
      reset_sub: "أدخل كلمة المرور الجديدة.",
      reset_done: "تم تحديث كلمة المرور. يمكنك تسجيل الدخول الآن.",
      send_reset: "أرسل رابط الاستعادة",
      new_password: "كلمة المرور الجديدة",
      update_password: "تحديث كلمة المرور",
      login_required_title: "يلزم تسجيل الدخول",
          or: "أو",
      continue_with_google: "المتابعة عبر Google",
      google_welcome: "أهلاً!",
      google_finishing: "جاري إتمام تسجيل الدخول عبر Google…",
      google_failed: "فشل تسجيل الدخول عبر Google",
      google_unavailable: "تسجيل الدخول عبر Google غير متاح حالياً.",
      pwd_mismatch: "كلمتا المرور غير متطابقتين",
      pwd_too_short: "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
      account_created: "تم إنشاء الحساب. أهلاً بك!",
},
    verify: {
      title: "تفعيل المفتاح",
      subtitle: "أدخل المفتاح الذي اشتريته.",
      placeholder: "KHA-XXXX-XXXX-XXXX",
      submit: "تحقّق من المفتاح",
      verifying: "جاري التحقق...",
      pick_game: "اختر اللعبة",
      pick_sub: "اختر لعبة واحدة لاستلامها.",
      deliver: "استلام",
      delivering: "جاري التسليم...",
      success: "حسابك",
      copy: "نسخ",
      copied: "تم النسخ!",
      username: "اسم مستخدم Steam",
      password: "كلمة المرور",
      guard_btn: "احصل على رمز Steam Guard",
      guard_fetching: "جاري البحث في البريد...",
      guard_title: "رمز Steam Guard",
      guard_retry: "إعادة المحاولة",
      guard_close: "إغلاق",
      cooldown_prefix: "متاح خلال",
      cooldown_notice: "متاح مجدداً بعد 72 ساعة.",
      cooldown_next: "الطلب التالي",
      cooldown_d: "ي",
      cooldown_h: "س",
      cooldown_m: "د",
      no_code: "لا يوجد رمز Steam Guard جديد بعد. أعد المحاولة بعد ثوانٍ.",
      gmail_not_connected: "خدمة Steam Guard غير متاحة لهذا الحساب حالياً. تواصل مع الدعم.",
      warning_save: "تم الحفظ في مكتبتك — متاح في أي وقت.",
      view_library: "اذهب إلى مكتبتي",
      login_required: "يرجى تسجيل الدخول أو إنشاء حساب لتفعيل المفاتيح.",
          verified_toast: "تم التحقق من المفتاح",
      delivered_toast: "تم التسليم!",
      game_added_prefix: "تمت إضافة اللعبة!",
      uses_remaining_suffix: "استخدام متبقٍ",
      no_products: "لا توجد منتجات متاحة لهذا المفتاح حالياً. حاول لاحقاً.",
},
    profile: {
      title: "مكتبتي",
      subtitle: "جميع ألعابك المستلمة. رموز Steam Guard متاحة 24/7.",
      empty: "لم تستلم أي لعبة بعد.",
      redeem_first: "فعّل مفتاحاً",
      delivered_on: "تم الاستلام",
      account_info: "بيانات الحساب",
      member_since: "عضو منذ",
      change_password: "تغيير كلمة المرور",
    },
    faq: {
      title: "الأسئلة الشائعة",
      items: [
        { q: "كيف أحصل على مفتاح؟", a: "اشترِ من متجرنا الخارجي. بصيغة KHA-XXXX-XXXX-XXXX." },
        { q: "هل أحتاج حساباً؟", a: "نعم — أنشئ حسابك لتُحفظ كل لعبة فعّلتها في مكتبتك للأبد." },
        { q: "هل البيانات آمنة؟", a: "نعم. جميع البيانات الحساسة مشفّرة بمستوى AES." },
        { q: "ماذا عن Steam Guard؟", a: "اضغط زر 'احصل على رمز Steam Guard' من أي لعبة في مكتبتك. يظهر آخر رمز تسجيل دخول خلال ثوانٍ." },
        { q: "هل يمكن إعادة استخدام المفتاح؟", a: "لا — مفتاح واحد للاستخدام مرة واحدة." },
        { q: "هل أستطيع الرجوع لألعابي لاحقاً؟", a: "نعم! كل لعبة فعّلتها تبقى في مكتبتك دائماً مع Steam Guard عند الطلب." },
      ],
    },
    contact: {
      title: "تواصل معنا",
      subtitle: "أسئلة، تقارير أخطاء، أو شراكات — راسلنا.",
      name: "اسمك",
      email: "البريد الإلكتروني",
      message: "الرسالة",
      send: "أرسل الرسالة",
      sent: "تم استلام رسالتك. سنرد خلال 24 ساعة.",
    },
    game: {
      view: "عرض التفاصيل",
      claim: "فعّل مفتاحاً لهذه اللعبة",
      delivered: "تم تسليمها",
    },
    games: {
      search_placeholder: "ابحث عن لعبة أو منصة…",
      results: "نتيجة",
      no_results: "لا توجد ألعاب تطابق بحثك.",
    },
    admin: {
      login: "دخول المسؤول",
      login_sub: "سجّل الدخول لإدارة KHA Games.",
      email: "البريد",
      password: "كلمة المرور",
      sign_in: "تسجيل دخول",
      dashboard: "نظرة عامة",
      products: "الألعاب",
      user_mgmt: "المستخدمون",
      keys: "المفاتيح",
      logs: "السجلات",
      users: "المستخدمون",
      logout: "تسجيل خروج",
    },
    common: {
      loading: "جاري التحميل...",
      empty: "لا يوجد شيء بعد.",
      error: "حدث خطأ.",
      save: "حفظ",
      cancel: "إلغاء",
      delete: "حذف",
      edit: "تعديل",
      add: "إضافة",
      yes: "نعم",
      no: "لا",
      confirm: "تأكيد",
      search: "بحث",
      status: "الحالة",
      actions: "الإجراءات",
      created: "أُنشئ",
    },
  },
  tr: {
    brand: "KHA GAMES",
    tagline: "Anında Oyun Hesap Teslimi",
    nav: {
      home: "Ana Sayfa",
      games: "Oyunlar",
      verify: "Kod Kullan",
      faq: "SSS",
      contact: "İletişim",
      admin: "Yönetim",
      sign_in: "Giriş Yap",
      sign_up: "Kayıt Ol",
      profile: "Profilim",
      logout: "Çıkış Yap",
      library: "Kitaplığım",
    },
    hero: {
      eyebrow: "Premium Steam Hesap Marketi",
      title: "Steam oyunlarına anında erişim, şifrelenmiş teslimatla güçlendirilmiş.",
      subtitle: "Kayıt ol, kodunu kullan, oyununu seç ve hesabını saniyeler içinde al — Steam Guard kodları otomatik getirilir.",
      cta_primary: "Kodunu Kullan",
      cta_secondary: "Oyunları Gör",
    },
    sections: {
      popular: "Öne Çıkan Oyunlar",
      popular_sub: "Hemen alınabilir mevcut oyunlar",
      latest: "Yeni Eklenenler",
      latest_sub: "Kitaplığımızdaki taze oyunlar",
      how_it_works: "Nasıl Çalışır",
      how_sub: "Üç adım. Şifrelenmiş. Anında.",
      step1_title: "Kod Satın Al",
      step1_desc: "Harici mağazamızdan bir KHA Games kodu satın al.",
      step2_title: "Sitede Kullan",
      step2_desc: "Giriş yap, kodunu gir, oyununu seç.",
      step3_title: "Hesabını Al",
      step3_desc: "Steam bilgileri + istek üzerine Steam Guard kodları.",
      features: "Neden KHA Games",
      f_secure: "AES Şifreli",
      f_secure_desc: "Her şifre Fernet AES ile şifrelenmiş.",
      f_instant: "Saniye altı teslim",
      f_instant_desc: "Atomik hesap tahsisi. Beklemeden.",
      f_steamguard: "Anında Steam Guard",
      f_steamguard_desc: "Tek bir buton — en son giriş kodu saniyeler içinde görünür.",
      f_24_7: "7/24 erişim",
      f_24_7_desc: "İstediğin zaman satın al ve oyna.",
    },
    auth: {
      welcome_back: "Tekrar hoş geldin",
      sign_in_sub: "Kodlarını kullanmak ve kitaplığına erişmek için giriş yap.",
      sign_up_sub: "Kodları kullanmaya başlamak için hesabını oluştur.",
      identifier: "Kullanıcı adı veya E-posta",
      username: "Kullanıcı adı",
      email: "E-posta",
      password: "Şifre",
      confirm_password: "Şifreyi onayla",
      have_account: "Zaten hesabın var mı?",
      no_account: "Hesabın yok mu?",
      forgot: "Şifreni mi unuttun?",
      forgot_title: "Şifre Sıfırlama",
      forgot_sub: "Kullanıcı adını veya e-postanı gir, sıfırlama bağlantısı gönderelim.",
      forgot_sent: "Hesap mevcutsa, sıfırlama bağlantısı gönderildi.",
      reset_title: "Yeni şifre belirle",
      reset_sub: "Aşağıya yeni şifreni gir.",
      reset_done: "Şifre güncellendi. Şimdi giriş yapabilirsin.",
      send_reset: "Sıfırlama bağlantısı gönder",
      new_password: "Yeni şifre",
      update_password: "Şifreyi güncelle",
      login_required_title: "Giriş gerekli",
          or: "veya",
      continue_with_google: "Google ile devam et",
      google_welcome: "Hoş geldin!",
      google_finishing: "Google girişi tamamlanıyor…",
      google_failed: "Google girişi başarısız",
      google_unavailable: "Google girişi şu anda kullanılamıyor.",
      pwd_mismatch: "Şifreler eşleşmiyor",
      pwd_too_short: "Şifre en az 8 karakter olmalı",
      account_created: "Hesap oluşturuldu. Hoş geldin!",
},
    verify: {
      title: "Kodunu Kullan",
      subtitle: "Satın aldığın kodu gir.",
      placeholder: "KHA-XXXX-XXXX-XXXX",
      submit: "Kodu Doğrula",
      verifying: "Doğrulanıyor...",
      pick_game: "Oyununu seç",
      pick_sub: "Almak için bir oyun seç.",
      deliver: "Al",
      delivering: "Teslim ediliyor...",
      success: "Hesabın",
      copy: "Kopyala",
      copied: "Kopyalandı!",
      username: "Steam Kullanıcı Adı",
      password: "Steam Şifre",
      guard_btn: "Steam Guard Kodu Al",
      guard_fetching: "Gelen kutusu taranıyor...",
      guard_title: "Steam Guard Kodu",
      guard_retry: "Tekrar dene",
      guard_close: "Kapat",
      cooldown_prefix: "Şu süre sonra:",
      cooldown_notice: "72 saat sonra tekrar kullanılabilir.",
      cooldown_next: "Sonraki istek",
      cooldown_d: "g",
      cooldown_h: "sa",
      cooldown_m: "dk",
      no_code: "Henüz yeni Steam Guard kodu yok. Birkaç saniye sonra tekrar dene.",
      gmail_not_connected: "Bu hesap için Steam Guard hizmeti henüz hazır değil. Destekle iletişime geçin.",
      warning_save: "Kitaplığına kaydedildi — istediğin zaman erişebilirsin.",
      view_library: "Kitaplığa Git",
      login_required: "Kodları kullanmak için lütfen giriş yapın veya kayıt olun.",
          verified_toast: "Kod doğrulandı",
      delivered_toast: "Teslim edildi!",
      game_added_prefix: "Oyun eklendi!",
      uses_remaining_suffix: "kullanım kaldı",
      no_products: "Bu kod için şu anda ürün yok. Daha sonra tekrar deneyin.",
},
    profile: {
      title: "Kitaplığım",
      subtitle: "Tüm aldığın oyunlar. Steam Guard kodları 7/24.",
      empty: "Henüz hiç oyun almadın.",
      redeem_first: "Bir Kod Kullan",
      delivered_on: "Alındığı tarih",
      account_info: "Hesap Bilgisi",
      member_since: "Üyelik tarihi",
      change_password: "Şifre değiştir",
    },
    faq: {
      title: "Sıkça Sorulan Sorular",
      items: [
        { q: "Kodu nasıl alırım?", a: "Harici mağazamızdan satın al. KHA-XXXX-XXXX-XXXX formatında olur." },
        { q: "Hesap gerekli mi?", a: "Evet — kayıt ol ve kullandığın her oyunu kitaplığında sonsuza dek sakla." },
        { q: "Şifrem güvenli mi?", a: "Evet. Hassas tüm veriler AES sınıfı şifrelemeyle korunur." },
        { q: "Steam Guard ne olacak?", a: "Kitaplığındaki herhangi bir oyun için 'Steam Guard Kodu Al' butonuna tıkla. En son giriş kodu saniyeler içinde görünür." },
        { q: "Kodu tekrar kullanabilir miyim?", a: "Hayır — her kod tek kullanımlıktır." },
        { q: "Oyunlarıma sonra erişebilir miyim?", a: "Evet! Kullandığın her oyun kitaplığında kalıcı, Steam Guard her zaman bir tık uzakta." },
      ],
    },
    contact: {
      title: "Bize ulaşın",
      subtitle: "Sorular, hata raporları, ortaklık talepleri — bize yazın.",
      name: "Adınız",
      email: "E-posta",
      message: "Mesaj",
      send: "Mesaj gönder",
      sent: "Mesaj alındı. 24 saat içinde yanıtlayacağız.",
    },
    game: {
      view: "Detayları gör",
      claim: "Bu oyun için kod kullan",
      delivered: "teslim edildi",
    },
    games: {
      search_placeholder: "Oyun veya platform ara…",
      results: "sonuç",
      no_results: "Aramanla eşleşen oyun yok.",
    },
    admin: {
      login: "Yönetici Girişi",
      login_sub: "KHA Games'i yönetmek için giriş yap.",
      email: "E-posta",
      password: "Şifre",
      sign_in: "Giriş yap",
      dashboard: "Gösterge Paneli",
      products: "Oyunlar",
      user_mgmt: "Kullanıcı Yönetimi",
      keys: "Kodlar",
      logs: "Kayıtlar",
      users: "Kullanıcılar",
      logout: "Çıkış yap",
    },
    common: {
      loading: "Yükleniyor...",
      empty: "Henüz bir şey yok.",
      error: "Bir şeyler ters gitti.",
      save: "Kaydet",
      cancel: "İptal",
      delete: "Sil",
      edit: "Düzenle",
      add: "Ekle",
      yes: "Evet",
      no: "Hayır",
      confirm: "Onayla",
      search: "Ara",
      status: "Durum",
      actions: "İşlemler",
      created: "Oluşturuldu",
    },
  },
};
